export const actionTypes: any = {
  // get
  GET_TISA_FOREX_RATE_CATEGORY_START: 'GET_TISA_FOREX_RATE_CATEGORY_START',
  GET_TISA_FOREX_RATE_CATEGORY_SUCCESS: 'GET_TISA_FOREX_RATE_CATEGORY_SUCCESS',
  GET_TISA_FOREX_RATE_CATEGORY_FINISH: 'GET_TISA_FOREX_RATE_CATEGORY_FINISH',
}
